import axios, { isAxiosError } from "axios";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeadersForMultipart } from "../util/build-axios-authentication-headers";

export interface UploadSupportAttachmentResponse {
  token: string;
  attachment_id: number;
}

export const postUploadAttachment = async (
  namespace: string,
  formData: FormData,
): Promise<UploadSupportAttachmentResponse> => {
  const url = supportUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeadersForMultipart(),
  };

  try {
    const response = await axios.post<UploadSupportAttachmentResponse>(
      `${url}/api/v1/ns/${namespace}/attachments`,
      formData,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to upload support attachment. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while uploading support attachment.",
    );
  }
};
